import { render, staticRenderFns } from "./boTrends.vue?vue&type=template&id=2c3ef896&"
import script from "./boTrends.vue?vue&type=script&lang=js&"
export * from "./boTrends.vue?vue&type=script&lang=js&"
import style0 from "./boTrends.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports